export default {
  STRIPE_CARD_DECLINED: 'stripe_card_declined',
  LANDLORD_BLACKLISTED: 'payment_not_allowed',
  PAYMENT_SOURCE_BLACKLISTED: 'source_not_processed',
  CARD_DECLINED_FOR_FAILED_ATTEMPTS: 'card_declined_failed_attempts',
  INSUFFICIENT_FUNDS: 'insufficient_funds',
  LEASE_RETRIEVAL_FAILED: 'lease_retrieval_failed',
};
